import React from 'react';
import { withRouter } from 'react-router-dom';
import { api_route, user_logout } from '../../helpers/Global';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import queryString from 'query-string';

class ColisLivrer extends React.Component {

    render() {
        return (
            <React.Fragment>
                <div className="modal-header border-0">
                    <h5 className="modal-title" style={{ 'opacity': '0' }}>Confirmation</h5>
                    <button type="button" className="close" onClick={() => this.props.showModal(false)}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <strong>Voulez-vous vraiment livrer cet colis ?</strong>
                </div>
                <div className="modal-footer border-0">
                    <button type="button" className="btn btn-outline-light" id="btnLivrerColi" onClick={() => this.submitColi()}>Valider</button>
                    <button type="button" className="btn btn-danger" onClick={() => this.props.showModal(false)}>Annuler</button>
                </div>
            </React.Fragment>
        );

    };

    submitColi = () => {
        this.props.loaderDisplay(true);
        const coli = this.props.selected_coli;
        var btn = document.getElementById('btnLivrerColi');
        btn.setAttribute('disabled', true);
        btn.classList.add('disabled');
        let formData = new FormData();
        formData.append('barecode', coli.barecode);
        formData.append('statut', 'delivered');
        fetch(api_route('change-statut-colis'), { method: 'POST', body: formData })
            .then(resp => resp.json())
            .then(resp => {
                this.props.loaderDisplay(false);
                
                if (resp.response === 'error-connected') {
                    user_logout();
                    this.props.history.push(`/user-logout`);
                } else if (resp.response === 'error') {
                    alertify.error(resp.message);
                } else if (resp.response === 'success') {

                    var params = queryString.parse(this.props.location.search);
                    var loc = this.props.location;
                    //var redirect_url = (loc.pathname + '?statut_shipped=' + params.statut_shipped + '&t=' + Date.now() + '&loader=false');
                    //console.log(redirect_url);
                    //this.props.history.replace(redirect_url);

                    this.props.showModal(false)
                    alertify.success(resp.message);
                    
                    this.props.setCurrentPage('list_colis');
                    var redirect_url = '/colis/shipped?t=' + Date.now()+'&loader=false';
                    this.props.history.push(redirect_url);
                    
                    
                    /*if (resp['info-general']) {
                        this.props.setLivreur(resp['info-general']);
                    }*/

                }
                btn.removeAttribute('disabled');
                btn.classList.remove('disabled');
            })
            .catch(err => {
                this.props.loaderDisplay(false);
                this.props.openErrorSystem(true);
            })
    }

}

export default withRouter(ColisLivrer)